import { loadSettings, saveSettings } from '@/config/localSettings';
import { type ThemeType } from '@contiple/antd-ds';
import { create } from 'zustand';

interface ThemeState {
  theme: ThemeType;
  setTheme: (theme: ThemeType) => void;
}

export const useThemeStore = create<ThemeState>((set) => ({
  theme: loadSettings().theme,
  setTheme: (theme) => {
    set({ theme });
    saveSettings({ theme });
  },
}));
